export default "__VITE_ASSET__DQebcJca__"